// AuthContext.js
import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({});

  const collection = {
    userInfo,
    setUserInfo,
  };

  return (
    <AuthContext.Provider value={collection}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
